import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@/plugins/vuex-async-pagginate';
import { ChargeService } from '@referral/services/ChargeService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => ChargeService.getList(params)
    }
  },
  true
);
